export default __webpack_public_path__ + "static/media/48_photo.d2ae1db6.jpg";